import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles, Play } from 'lucide-react';

export function Hero() {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5" />
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent/20 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary mb-8 animate-fade-in">
            <Sparkles className="w-4 h-4" />
            <span className="text-sm font-medium">AI-Powered Commerce Platform</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-6 animate-slide-up">
            Turn WhatsApp Messages{' '}
            <span className="gradient-text">Into Orders</span>{' '}
            Automatically
          </h1>

          {/* Subheadline */}
          <p className="text-lg lg:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto animate-slide-up stagger-1">
            SparkCommerce is the all-in-one platform that helps businesses sell on WhatsApp 
            with AI-powered conversations, POS, inventory management, and invoicing.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slide-up stagger-2">
            <Link to="/signup">
              <Button size="lg" className="h-12 px-8 text-base rounded-full shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/30 transition-all">
                Start Free Trial
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
            <Button variant="outline" size="lg" className="h-12 px-8 text-base rounded-full">
              <Play className="mr-2 h-5 w-5" />
              Watch Demo
            </Button>
          </div>

          {/* Trust badges */}
          <div className="mt-12 pt-8 border-t border-border/50 animate-fade-in stagger-3">
            <p className="text-sm text-muted-foreground mb-4">
              Trusted by 1,000+ businesses across India
            </p>
            <div className="flex items-center justify-center gap-8 opacity-60">
              <div className="text-lg font-semibold">4.9/5 Rating</div>
              <div className="h-4 w-px bg-border" />
              <div className="text-lg font-semibold">10K+ Orders/Day</div>
              <div className="h-4 w-px bg-border" />
              <div className="text-lg font-semibold">99.9% Uptime</div>
            </div>
          </div>
        </div>

        {/* Hero Image/Dashboard Preview */}
        <div className="mt-16 lg:mt-24 relative animate-scale-in stagger-4">
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent z-10" />
          <div className="relative mx-auto max-w-6xl rounded-2xl border border-border/50 shadow-2xl overflow-hidden bg-card">
            <div className="aspect-[16/9] bg-muted/20">
              <img
                src={`${process.env.PUBLIC_URL}/Screenshot_1.png`}
                alt="SparkCommerce dashboard screenshot"
                className="h-full w-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
